// Beta keeps series planning to writer-written notes plus an ordered list of books
// (Joel lock #1417, 2026-10-07). true brings back the series planning tools: Get Book
// Ideas, Gap, Entrance, Exit and Reveal on the Timeline, the series shape cards in
// Series Discovery, and Make notes from chats and docs. Pins already on a board still show.
export const SERIES_PLANNING_TOOLS = false;
